import finixService, { FinalizeFinix } from "lib/features/finix/finixService";
import { useEffect, useState } from "react";
import { usePlaidLink } from "react-plaid-link";
import { useParams } from "react-router-dom";

export default function PlaidPage() {
  const routeValue = useParams();
  const [onboardingToken, setOnboardingToken] = useState<string>("");
  useEffect(() => {
    if (routeValue.id !== undefined) {
      finixService
        .getOnboardingToken({ user_id: Number(routeValue.id) })
        .then((data) => {
          setOnboardingToken(data.data.toString());
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [routeValue.id]);
  const { open, ready } = usePlaidLink({
    token: onboardingToken,
    onSuccess: (public_token, metadata) => {
      let data: FinalizeFinix = {
        token: public_token,
        account_id: metadata.accounts[0].id,
        user_id: Number(routeValue.id),
      };
      finixService.finalizeOnboarding(data).then((result) => {});
    },
  });

  return (
    <>
      <button onClick={() => open()} disabled={!ready}>
        Connect a bank account
      </button>
    </>
  );
}
